import {
  FuneraryFillLargeIcon,
  ImportantDevicesFillLargeIcon,
  MysteryFillLargeIcon,
  token,
  UrnFillLargeIcon,
} from '@ferreri/prever-component-lib';

// TODO: temporary move of federated modules (posthumous-web pending)
export const existingServices = [
  {
    id: 1,
    title: 'Velório Online',
    description:
      'Familiares e amigos podem acompanhar a cerimônia de velório, mesmo não estando presentes.',
    icon: (
      <ImportantDevicesFillLargeIcon
        color={token.colors.solidPostumosPrimaryPure}
      />
    ),
    states: ['PR', 'SC'],
    link: 'https://www.planoprever.com.br/velorioonline',
  },
  {
    id: 2,
    title: 'Consulta de Falecimento',
    description: 'Consulta de pessoa falecida e informações sobre o velório. ',
    icon: (
      <MysteryFillLargeIcon color={token.colors.solidPostumosPrimaryPure} />
    ),
    states: ['PR', 'SC'],
    link: 'https://falecimentos.funerariasprever.com.br/',
  },
  {
    id: 3,
    title: 'Crematório',
    description:
      'Pensado especialmente para despedidas e homenagens profundas e emocionantes.',
    icon: <UrnFillLargeIcon color={token.colors.solidPostumosPrimaryPure} />,
    states: ['PR', 'SC'],
    link: 'https://www.angelussul.com.br/crematorio',
  },
  {
    id: 4,
    title: 'Velório Online',
    description:
      'Familiares e amigos podem acompanhar a cerimônia de velório, mesmo não estando presentes.',
    icon: (
      <ImportantDevicesFillLargeIcon
        color={token.colors.solidPostumosPrimaryPure}
      />
    ),
    states: ['RS'],
    link: 'https://www.angelus.com.br/velorioonline',
  },
  {
    id: 5,
    title: 'Consulta de Falecimento',
    description: 'Consulta de pessoa falecida e informações sobre o velório. ',
    icon: (
      <MysteryFillLargeIcon color={token.colors.solidPostumosPrimaryPure} />
    ),
    states: ['RS'],
    link: 'http://obituarios.angelus.com.br/',
  },
  {
    id: 6,
    title: 'Funerárias',
    description:
      'Todas as providências necessárias para o momento da despedida.',
    icon: (
      <FuneraryFillLargeIcon color={token.colors.solidPostumosPrimaryPure} />
    ),
    states: ['RS'],
    link: 'https://www.angelus.com.br/funeraria',
  },
  {
    id: 7,
    title: 'Jazigo',
    description:
      'Todo ciclo de vida é respeitado com empreendimentos modernos e sustentáveis.',
    icon: (
      <FuneraryFillLargeIcon color={token.colors.solidPostumosPrimaryPure} />
    ),
    states: ['PR'],
    link: 'https://www.angelussul.com.br/cemiteriovertical',
  },
  {
    id: 8,
    title: 'Memorial e Crematório',
    description:
      'Todo ciclo de vida é respeitado com empreendimentos modernos e sustentáveis.',
    icon: <UrnFillLargeIcon color={token.colors.solidPostumosPrimaryPure} />,
    states: ['RS'],
    link: 'https://www.angelus.com.br/memorial',
  },
];
